'use client'

import Loader from "@/Layout/Loader";
import CustomFetch from "@/Utils/APIRequest/AxiosInstance";
import { TermsConditionsAPI } from "@/Utils/APIRequest/Endpoints";
import { useTranslation } from "@/Utils/Hooks/useTranslate";
import { useQuery } from "@tanstack/react-query";

const TermsAndCondition = () => {
  const { translations } = useTranslation();
  const { data, isPending } = useQuery({ queryKey: [TermsConditionsAPI], queryFn: () => CustomFetch({ url: TermsConditionsAPI }, null, false), refetchOnWindowFocus: false, select: (data) => data?.data?.data });

  if (isPending) return <Loader />

  return (
    <>
      <div className="">
        <h2 className="text-primary text-xl mb-9 font-medium leading-6">📄 {translations?.termsConditions}</h2>
        {/* <span className="text-lg leading-normal font-medium mb-4 block">{translations?.lastUpdatedOn} 20 nov 2024</span> */}
        <div className="text-sm leading-normal font-normal custom-content" dangerouslySetInnerHTML={{ __html: data?.description }}></div>
      </div>
    </>
  );
};

export default TermsAndCondition;
